import type { ReactNode, ErrorInfo } from 'react';
import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';
import { useSentry } from '../sentry';
import { shouldSendToSentry } from './should-send-to-sentry';

export function QontoErrorBoundary(props: ErrorBoundaryProps): ReactNode {
  const sentry = useSentry();

  const onError = (error: Error, info: ErrorInfo): void => {
    if (shouldSendToSentry(error)) {
      sentry.captureException(error);
    }
    props.onError?.(error, info);
  };

  return <ErrorBoundary {...props} onError={onError} />;
}
